import React from "react";
import Layout from "../../../components/organisms/Layout";
import DynamicComponent from "../../../components/molecules/DynamicComponent";

import Storyblok, { useStoryblok } from "../../../utils/storyblok";
import Product from "../../../components/templates/Product";

export default function ProductPage({ story, preview }) {
  const enableBridge = true; // load the storyblok bridge everywhere
  // const enableBridge = preview; // enable bridge only in prevew mode
  story = useStoryblok(story, enableBridge);

  return (
    <Layout>
      <Product blok={story.content} story={story} />
    </Layout>
  );
}

export async function getStaticProps({ params, preview = false }) {
  let slug = params.slug;

  let sbParams = {
    version: "published", // or published
    resolve_relations: ["Product.category", "Product.type", "Product.color"],
  };

  if (preview) {
    sbParams.version = "draft";
    sbParams.cv = Date.now();
  }

  let { data } = await Storyblok.get(`cdn/stories/shop/product/${slug}`, sbParams);

  return {
    props: {
      story: data ? data.story : null,
      preview,
    },
    revalidate: 10, // revalidate every hour
  };
}

export async function getStaticPaths() {
  let { data } = await Storyblok.get("cdn/links/", {
    starts_with: "shop/product/",
  });

  let paths = [];

  Object.keys(data.links).forEach((linkKey) => {
    if (data.links[linkKey].is_folder || data.links[linkKey].slug === "home") {
      return;
    }

    // get array for slug because of catch all
    const slug = data.links[linkKey].slug;

    let splittedSlug = slug.split("/");
    paths.push({ params: { slug: splittedSlug[2] } });
  });

  return {
    paths: paths,
    fallback: false,
  };
}
